import type { locationChangeAction } from 'redux-first-history/build/es6/actions';

import type { PermissionsItem } from '@/modules/api/codegen';
import type { store } from '@/modules/core/modules/redux';

export type Store = typeof store;

export type AppState = ReturnType<Store['getState']>;

export enum AccessRole {
    EDITOR = 'editor',
    VIEWER = 'viewer',
    VIEWER_AUTOFILL_ONLY = 'autofillOnly',
    VIEWER_PASSKEY_ONLY = 'passkeyOnly',
}

export interface EntityWithPermissions {
    id: string;
    accessPermissions: PermissionsItem[];
}

export interface ApiError<D extends Record<string, any> = {}, C extends string = string> {
    code: number;
    message: string;
    errorCode: C;
    errorClass: string;
    errorData: D;
}

export interface SaasLimits {
    maxSecrets: number;
    beforeImport: number;
    afterImport: number;
    importAmount: number;
}

export type LocationChangeAction = ReturnType<typeof locationChangeAction>;
